import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'
import type moment from 'moment'

import { dateToString, stringToDate } from 'modules/core/lib/dates'

const LOGS_PERIOD_TYPES = Object.freeze({
  monthly: 'monthly',
})

export const DEFAULT_PERIOD_TYPE = LOGS_PERIOD_TYPES.monthly

class FaceRecognitionLogsForm extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      date: 'date',
    })
    makeObservable(this, {
      startOn: computed,
      endOn: computed,
    })
  }

  get startOn(): moment.Moment {
    return stringToDate(this.date.clone().startOf('month') as any, 'ui')
  }

  get endOn(): moment.Moment {
    return stringToDate(this.date.clone().endOf('month') as any, 'ui')
  }

  get date(): moment.Moment {
    return stringToDate(this.get('date').value, 'ui')
  }

  changePeriod(date: moment.Moment) {
    this.setValues({
      date: dateToString(date, 'backend'),
    })
  }
}

export default FaceRecognitionLogsForm
